export class EngageEvent {
    engageEventType: string;
    engagementId: number;
    collaborationSiteId:number;
    engagementName: string;
    indusConsent: string;
    clientConsent: string;
    createdBy: string;
}
